import { render, staticRenderFns } from "./FetchEmailCampaignsBtn.vue?vue&type=template&id=4f91caf8&"
import script from "./FetchEmailCampaignsBtn.vue?vue&type=script&lang=ts&"
export * from "./FetchEmailCampaignsBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
